<app-label [ngClass]="labelType" [icon]="icon" [text]="text | translate" [onlyIcon]="isMobile$ | async"></app-label>